import script from "./date-ranges-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-ranges-input.vue?vue&type=script&setup=true&lang=ts"

import "./date-ranges-input.vue?vue&type=style&index=0&id=3aa7433b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa7433b"]])

export default __exports__